import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable and override browser scroll restoration.
// Without this, the browser overrides window.scrollTo(0, 0) on navigation.
if (typeof window !== 'undefined') {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        const element = document.getElementById(hash.slice(1)); // strip hash
        if (element) {
          element.scrollIntoView();
        }
      });
    } else {
      // html { overflow: hidden } from css makes body the scroll root
      document.body.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
